<template>
    <el-dialog
        width="65%"
        title="预签收日志"
        :visible="true"
        :close-on-click-modal="false"
        :before-close="handleClose"
        class="configurationLogDialog"
    >
        <div class="log-dialog-table">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                v-loading="loading"
                resizable="true"
                show-overflow-tooltip="true"
                height="400"
            >
                <el-table-column prop="createTime" label="操作时间" width="130"  align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="createUserName" label="操作人" width="130" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="itemCode" label="商品编码" width="100" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="itemName" label="商品名称" width="200" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="goodSignQty" label="正品签收" align="center"></el-table-column>
                <el-table-column prop="packingdmgSignQty" label="箱损签收" align="center"></el-table-column>
                <el-table-column prop="goodRejectQty" label="正品拒收" align="center"></el-table-column>
                <el-table-column prop="packingdmgRejectQty" label="箱损拒收" align="center"></el-table-column>
                <el-table-column prop="machinedmgRejectQty" label="机损拒收" align="center"></el-table-column>
                <el-table-column prop="shortQty" label="短少" align="center"></el-table-column>
            </el-table>
        </div>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :disabled="+countData === 0"
            :current-page.sync="query.pageNo"
            :page-size="query.pageSize"
            :page-sizes="[10, 30, 50, 100]"
            :total="countData"
            layout="total, sizes, prev, pager, next"
        ></el-pagination>
    </el-dialog>
</template>
<script>
import { getLogDataList } from '@/modules/transport/otp/api/performanceReceiptSign.js';
export default {
    name: 'operationLogDialog',
    props: {
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            countData: 0,
            tableData: [],
            loading: false,
            query: {
                pageNo: 1,
                pageSize: 10
            }
        };
    },
    mounted () {
        this.getListData();
    },
    methods: {
        // 获取列表数据
        getListData () {
            const params = {
                ...this.query,
                param: {
                    taskNo: this.rowData.taskNo
                }
            };
            getLogDataList(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.tableData = res.data.list || [];
                        this.countData = res.data.totalCount || 0;
                    }
                })
                .finally(() => { this.loading = false; })
                .catch(() => { });
        },
        // 切换页面数据条数
        handleSizeChange (pageSize) {
            this.query.pageNo = 1;
            this.query.pageSize = pageSize;
            this.getListData();
        },
        // 切换分页
        handleCurrentChange (pageNo) {
            this.query.pageNo = pageNo;
            this.getListData();
        },
        // 关闭当前弹窗
        handleClose () {
            this.$emit('update:logDialogVisible', false);
        }
    }
};
</script>
<style lang="less" scoped>
.configurationLogDialog {
    .log-dialog-table {
        min-height: 200px;
        max-height: 500px;
        overflow: auto;
    }

    .el-dialog__body {
        margin: 15px 15px;
    }

    .el-table {
        margin-bottom: 35px;
        min-height: 150px;
    }

    .el-pagination,
    .el-button {
        font-weight: normal;
        text-align: right;
    }

    .el-pagination .el-select .el-input {
        width: 70px;
    }
}
</style>
